import React from 'react';

import useNavigateReplace from '../../hooks/useNavigateReplace';
import rumCustomEvents from '../../services/events/rumCustomEvents';
import {twx} from '../../utils/tailwindUtils';

const NavigationButton = ({
    route,
    onClick,
    className,
    isFixed = true,
    isRightAlign,
    rumActionName = '',
    isClickTracked = true,
    children,
}) => {
    const navigate = useNavigateReplace();

    const onButtonClick = () => {
        if (isClickTracked) {
            rumCustomEvents.recordActionClick({rumActionName});
        }
        if (onClick) {
            onClick();
            return;
        }

        navigate(route);
    };

    const Wrapper = ({children}) =>
        isFixed ? (
            <div
                className={twx(
                    'group fixed left-1/2 top-6 z-30 mt-safe-top flex h-0 w-full max-w-md -translate-x-1/2 px-6',
                    isRightAlign ? 'justify-end' : 'justify-start',
                    className
                )}
            >
                {children}
            </div>
        ) : (
            <div className={twx('group', className)}>{children}</div>
        );

    return (
        <Wrapper>
            <div
                onClick={onButtonClick}
                className={twx(
                    'relative z-30 cursor-pointer',
                    'before:absolute before:-inset-6 before:block before:h-20 before:w-20 group-[.disable-hit-area]:before:hidden'
                )}
            >
                {children}
            </div>
        </Wrapper>
    );
};

export default NavigationButton;
